<template>
  <div>
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="top">
                <img src="@/assets/multiply.png" @click="close" />
                <h4>
                  Library
                </h4>
              </div>
              <div class="modal-body">
                <table>
                  <tbody>
                    <tr
                      v-for="category in categories"
                      :key="category.id"
                      @click="getCategoryItems(category.id)"
                    >
                      <td id="avatar">Y</td>
                      <td id="text">{{ category.name }}</td>
                      <td id="selector"></td>
                    </tr>
                  </tbody>
                </table>
                <Items
                  v-show="selectItemsVisible"
                  @close="selectItemsVisible = false"
                  :items="categoryItems"
                  @selectedItem="showSelectedItem"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Items from "./Items";

export default {
  name: "Category",
  components: {
    Items
  },
  props: {
    categories: {
      type: Array
    },
    items: {
      type: Array
    }
  },
  data() {
    return {
      categoryItems: [],
      selectItemsVisible: false
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    getCategoryItems(id) {
      this.categoryItems = this.items.filter(item => {
        return item.category_id == id;
      });
      this.selectItemsVisible = true;
    },
    showSelectedItem(event) {
      this.selectItemsVisible = false;
      this.$emit("close");
      this.$emit("selectedItem", event);
    }
  }
};
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.modal-content {
  border-radius: 0;
  height: 400px;
  width: 600px;
}
.top {
  margin-bottom: 64px;
}
.top img {
  float: left;
  padding: 33px 0px 0px 34px;
}
.top h4 {
  text-align: center;
  margin-top: 54px;
  color: #37383b;
  font-size: 23px;
  font-weight: bold;
}
.modal-body {
  padding-left: 140px;
  padding-right: 140px;
  margin-bottom: 64px;
  overflow: scroll;
}
table tbody tr:nth-child(1) {
  border-top: 1px solid silver;
}
table tbody tr #avatar {
  width: 43px;
  color: #ffffff;
}
table tbody tr:nth-child(odd) #avatar {
  background: #d0312d;
}
table tbody tr:nth-child(even) #avatar {
  background: #991002;
}
table tbody tr #text {
  text-align: left;
}
@media (max-width: 768px) {
  .modal-content {
    height: 400px;
    width: 100%;
  }
  .modal-body {
    padding-left: 30px;
    padding-right: 30px;
    margin-bottom: 30px;
  }
}
</style>
